import React from 'react';

function RenderProfilePic({ thumbnail, name, size = 4, className }) {

  console.log(thumbnail, 'asjkd');
  return (
    <span className={className}>
      {thumbnail ? (
        <img
          src={thumbnail}
          alt='User Profile'
          className='rounded-full object-cover inline mr-2'
          style={{
            width: size + 'rem',
            minWidth: size + 'rem',
            height: size + 'rem',
          }}
        />
      ) : (
        <span
          className='bg-blue-200 inline-flex items-center justify-center rounded-full mr-2'
          style={{ width: size + 'rem', height: size + 'rem' }}
        >
          <span className='text-2xl uppercase font-bold text-blue-500'>
            {name?.substr(0, 1)}
          </span>
        </span>
      )}
    </span>
  );
}

export default RenderProfilePic;
